// extracted by mini-css-extract-plugin
export default {"tx":"_8b3fdb8def","line":"_651731b897"};